import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { DEFAULT_LANGUAGE, getSupportedLanguages } from "@devowl-wp/api-real-cookie-banner";
import { moveArrayElementsToBeginning } from "@devowl-wp/react-frontend";
import { TranslationTextAreaFormFieldEntry } from "./language-text-area-form-field-entry.js";
import { useStores } from "../../../../../../../store/root.js";
const TranslationTextAreaFormFields = observer((props)=>{
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const languages = useMemo(()=>{
        return moveArrayElementsToBeginning(getSupportedLanguages(false), translationSettings.sourceLanguage, translationSettings.targetLanguage).filter((lang)=>lang !== DEFAULT_LANGUAGE);
    }, [
        translationSettings?.sourceLanguage,
        translationSettings?.targetLanguage
    ]);
    const { flexPathConfig, customPlaceholder, formProps, textAreaProps } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: languages.map((lang)=>/*#__PURE__*/ _jsx(TranslationTextAreaFormFieldEntry, {
                lang: lang,
                flexPathConfig: flexPathConfig,
                customPlaceholder: customPlaceholder,
                formProps: formProps,
                textAreaProps: textAreaProps
            }, lang))
    });
});
export { TranslationTextAreaFormFields };
